import React from 'react';
import Header from "../components/Header/Header";
import {Flex} from "antd";
import Footer from "../components/Footer/Footer";
import {useWindowSize} from "@uidotdev/usehooks";
import Banner from "./components/Banner";
import ProjectGoals from "./components/ProjectGoals";
import TeamSection from "./components/TeamSection";
import NewsSection from "./components/NewsSection";

const HomePage = () => {
    const size = useWindowSize();
    return (
        <div>
            <Header/>
            <Banner/>
            <ProjectGoals/>
            <TeamSection/>
            <NewsSection/>
            <Flex style={{width: "100%", position: "relative", padding: "20px 20px 20px 20px"}} align={"center"} justify={"center"}>
                <Flex gap={50} style={{width: "100%", maxWidth: 1440, position: "relative"}} vertical align={"flex-start"} justify={"flex-start"}>

                </Flex>
            </Flex>
            <Footer/>
        </div>
    );
};

export default HomePage;